import { Vue, Options } from 'vue-class-component';
import {
  PlantDTO,
  ServerModel,
} from '@/../client-generator/generated-clients/plants';
import { getRoomIconFromType } from '@/core/utils/utils';
import { DefaultRoomDTO } from '@/../client-generator/generated-clients/configurations';

import NumberButtons from '@/views/components/NumberButtons/NumberButtons.vue';
import { mapGetters } from 'vuex';

@Options({
  name: 'DialogPlantCreateStep2',
  props: {
    plant: {
      required: true,
      type: Object as () => PlantDTO,
    },
  },
  computed: {
    ...mapGetters('UI', ['plantServerShowC300', 'plantServerShowF460']),
  },
  components: {
    NumberButtons,
  },
  emits: ['is-loading'],
})
export default class DialogPlantCreateStep2 extends Vue {
  plant!: PlantDTO;
  ServerModel = ServerModel;
  roomTypes: DefaultRoomDTO[] = [];
  getRoomIcon = getRoomIconFromType;
  private readonly plantServerShowC300!: boolean;
  private readonly plantServerShowF460!: boolean;

  get plantServerImages() {
    const serverConfigs = [
      {
        imageURLs: [require('@/assets/images/plants/server/image_gateway_c300eos.svg')],
        value: ServerModel.Classe300EOS,
        showCondition: this.plantServerShowC300,
      },
      {
        imageURLs: [require('@/assets/images/plants/server/image_gateway_mhs1.svg')],
        value: ServerModel.MyHomeServer1,
        showCondition: true,
      },
      {
        imageURLs: [require('@/assets/images/plants/server/image_gateway_f460.svg')],
        value: ServerModel.F460,
        showCondition: this.plantServerShowF460,
      },
      {
        imageURLs: [require('@/assets/images/plants/server/image_gateway_f460.svg')],
        value: ServerModel.F461,
        showCondition: this.plantServerShowF460,
      },
    ];

    return serverConfigs.filter(config => config.showCondition);
  }

  async created() {}

  updatePlantRoom(room: DefaultRoomDTO) {
    const plantRoom = this.plant.roomsCounts?.find(
      (rc) => rc.type === room.type
    );

    if (!plantRoom) {
      console.log('Plant room not found');
      return;
    }

    plantRoom.count = room.count;
  }
}
